import styled from "styled-components";
import { COLORS } from "../../utils";

export const Container = styled.div`
  .drag-drop {
    background: #fff;
    border: 1px solid var(--border-color);
    border-radius: 8px;
  }

  .document-uploader {
    border: 1px dashed #b1bfd0;
    background-color: #ffffff;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 8px;

    &.active {
      border-color: ${COLORS.green};
    }

    &.dragging {
      background-color: ${COLORS.primary50} !important;
      color: ${COLORS.primary500} !important;
    }

    .upload-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;

      svg {
        font-size: 48px;
        margin-bottom: 5px;
      }

      div {
        p {
          margin: 0;
          font-size: 14px;
          line-height: 18px;

          span {
            color: ${COLORS.primary400} !important;
            font-weight: normal !important;
            cursor: pointer;
          }
        }

        p:first-child {
          font-weight: bold;
        }
      }
    }

    .file-list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      width: 100%;
      height: auto;
      &__container {
        width: 100%;
        height: 100%;
        overflow: auto;
      }
    }

    .file-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem;
      border: 1px solid var(--border-color);
      border-radius: 8px;

      .file-info {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        flex: 1;

        p {
          margin: 0;
          font-size: 14px;
          color: #333;
        }
      }

      .file-actions {
        cursor: pointer;

        svg {
          font-size: 18px;
          color: #888;
        }

        &:hover {
          svg {
            color: #d44;
          }
        }
      }
    }

    .browse-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5rem 1rem;
      border: 1px solid var(--border-color);
      border-radius: 8px;
      cursor: pointer;
      background-color: var(--primary-color);
      &:hover {
        background-color: transparent;
      }
    }

    .success-file {
      display: flex;
      align-items: center;
      color: #6dc24b;

      p {
        margin: 0;
        font-size: 14px;
        font-weight: bold;
      }
    }

    input[type="file"] {
      display: none;
    }
  }
`;
